import 'numeral/locales/en-gb';

import numeral from 'numeral';

import {
  CURRENCY_CODE,
  CURRENCY_SYMBOL_TO_CODE_MAP,
  SUPPORTED_CURRENCIES,
} from '@/constants/common';

const budgetRegexFormats = [
  /^([$€£]|د\.إ|¥|kr|HK\$|₹|ر\.ق|ر\.س|S\$|R|₨|NZ\$|USD|AUD|EUR|CAD|GBP|AED|JPY|CNY|DKK|HKD|INR|NOK|QAR|SAR|SGD|SEK|ZAR|PKR|NZD)?\s*([\d,.]+)\s*([MK]?)$/i,
  /^([\d,.]+)\s*([MK]?)\s*([$€£]|د\.إ|¥|kr|HK\$|₹|ر\.ق|ر\.س|S\$|R|₨|NZ\$|USD|AUD|EUR|CAD|GBP|AED|JPY|CNY|DKK|HKD|INR|NOK|QAR|SAR|SGD|SEK|ZAR|PKR|NZD)?$/i,
];

numeral.locale('en-gb');

export const parseBudget = (
  budget: string
): { currency: keyof typeof CURRENCY_CODE; value: number } => {
  let parsedBudget = {
    currency: CURRENCY_CODE.GBP as keyof typeof CURRENCY_CODE,
    value: 0,
  };

  if (budget.match(budgetRegexFormats[0])) {
    const match = budget.match(budgetRegexFormats[0])!;

    const isCurrencySymbol = match[1] && SUPPORTED_CURRENCIES.map(c => c.symbol).includes(match[1]);
    const currency = (
      isCurrencySymbol
        ? CURRENCY_SYMBOL_TO_CODE_MAP[match[1] as keyof typeof CURRENCY_SYMBOL_TO_CODE_MAP]
        : match[1] || CURRENCY_CODE.GBP
    ) as keyof typeof CURRENCY_CODE;

    const valueString = match[2];
    const cleanedValue = valueString.replace(/,/g, '');
    const value = parseFloat(cleanedValue) || 0;

    const shortcut = match[3];
    parsedBudget = parseBudgetWithShortcut({
      currency,
      shortCut: shortcut,
      value,
    });
  } else if (budget.match(budgetRegexFormats[1])) {
    const match = budget.match(budgetRegexFormats[1])!;

    const isCurrencySymbol = match[3] && SUPPORTED_CURRENCIES.map(c => c.symbol).includes(match[3]);
    const currency = (
      isCurrencySymbol
        ? CURRENCY_SYMBOL_TO_CODE_MAP[match[3] as keyof typeof CURRENCY_SYMBOL_TO_CODE_MAP]
        : match[3] || CURRENCY_CODE.GBP
    ) as keyof typeof CURRENCY_CODE;

    const shortcut = match[2];
    const valueString = match[1];

    const cleanedValue = valueString.replace(/,/g, '');
    const value = parseFloat(cleanedValue) || 0;

    parsedBudget = parseBudgetWithShortcut({
      currency,
      shortCut: shortcut,
      value,
    });
  }
  return parsedBudget;
};

const parseBudgetWithShortcut = ({
  shortCut,
  currency,
  value,
}: {
  currency: keyof typeof CURRENCY_CODE;
  shortCut: string;
  value: number;
}) => {
  if (shortCut === 'K') {
    return { currency, value: value * 1000 };
  }
  if (shortCut === 'M') {
    return { currency, value: value * 1000000 };
  }
  return { currency, value };
};
